import { render, staticRenderFns } from "./ManajemenSistem.vue?vue&type=template&id=75ed1493&"
import script from "./ManajemenSistem.vue?vue&type=script&lang=js&"
export * from "./ManajemenSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports